import { render, staticRenderFns } from "./GantiNoRM.vue?vue&type=template&id=5be5b32c"
import script from "./GantiNoRM.vue?vue&type=script&lang=js"
export * from "./GantiNoRM.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\Work\\laporan-rl\\sembiring_rekammedis\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5be5b32c')) {
      api.createRecord('5be5b32c', component.options)
    } else {
      api.reload('5be5b32c', component.options)
    }
    module.hot.accept("./GantiNoRM.vue?vue&type=template&id=5be5b32c", function () {
      api.rerender('5be5b32c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/app/home/master_pasien/GantiNoRM.vue"
export default component.exports